import { apiGetCities } from '@/api';
import * as types from '@/store/mutation-types';

// initial state
const state = {
  all: [],
};

// mutations
const mutations = {
  [types.RECEIVED_CITIES] (state, data) {
    data.data.forEach(function (element) {
      element.enabled = false;
    });

    state.all = data.data;
  },

  [types.UPDATE_CITIES_ENABLED] (state, data) {
    state.all.forEach(el => el.enabled = false);
    state.all.find((el) => {
      if (el.id === data.id) {
        el.enabled = data.enabled;
      }
    });
  },
};

const actions = {
  getCities: ({ commit }, args = {}) => {
    return apiGetCities(args).then(({ data }) => {
      // success
      commit(types.RECEIVED_CITIES, data);
    })
    .catch((error) => {
      console.log(error);
    });
  },

  toggleCityEnabledFilter: ({ commit, dispatch, state }, data) => {
    commit(types.UPDATE_CITIES_ENABLED, data);
  },
};

const getters = {
  cities (state) {
    return state.all;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/cities.js